import { AnyType } from '@src/models/common';

/** Функция проверяет, что переданный параметр является не пустым массивом
 * @param v проверяемый объект
 * @param iterable будем ли проверять все итерируемые объекты, такие как Set и Map
 */
// Перегрузки для разных случаев:
export function isNotEmptyArray<T>(v: T | T[], iterable?: false): v is T[];
export function isNotEmptyArray<T>(
  v: T | T[] | Set<T> | Map<unknown, T>,
  iterable: true,
): v is T[] | Set<T> | Map<unknown, T>;
export function isNotEmptyArray<T>(
  v: T | T[] | Set<T> | Map<unknown, T>,
  iterable?: boolean,
): v is T[] | Set<T> | Map<unknown, T> {
  // Проверка на null и undefined
  if (v == null) return false;

  // Если iterable=false или не указан, проверяем только массивы
  if (!iterable) {
    return Array.isArray(v) && v.length > 0;
  }

  // Проверка массивов
  if (Array.isArray(v)) return v.length > 0;

  // Проверка Set и Map
  if (v instanceof Set || v instanceof Map) return v.size > 0;

  // Все остальные случаи
  return false;
}

/** Функция проверяет, что переданный параметр является пустым массивом
 * @param v проверяемый объект
 * @param iterable будем ли проверять все итерируемые объекты, такие как Set и Map
 * @deprecated используй `isNotEmptyArray`
 */
export const isEmptyArray = (v: AnyType, iterable?: boolean) => {
  if (!iterable) return Array.isArray(v) && v.length === 0;

  if (typeof v !== 'object') return false;
  if (Array.isArray(v) && v.length === 0) return true;

  return typeof v.size === 'number' && v.size === 0;
};
